import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';

export interface DraggableDriver extends BaseDriver {
  beginDrag: (details: { dataHook: string }) => void;
  dragOver: (details: { dataHook: string }) => void;
  endDrag: (details: { dataHook?: string }) => void;
}
